import { fetchData, putData, sendData, deleteData } from '../../global-declare-components/api/network';

const basketAPI = {
  fetch:(slug, params) => fetchData(`/api/landing-page/${slug}/basket`, {params}),
  update:(slug, data) => putData(`/api/landing-page/${slug}/basket`, data),
  clear:(slug, params) => deleteData(`/api/landing-page/${slug}/basket`, {params}),
  sendCoupon:(slug, data) => sendData(`/api/landing-page/${slug}/basket/coupons`, data),
  fetchCustomer:(slug, params) => fetchData(`/api/landing-page/${slug}/basket/customer`, {params}),
  updateCustomer:(slug, data) => putData(`/api/landing-page/${slug}/basket/customer`, data),
  fetchAttendees:(slug, params) => fetchData(`/api/landing-page/${slug}/basket/attendees`, {params}),
  updateAttendees:(slug, data) => putData(`/api/landing-page/${slug}/basket/attendees`, data),
  updateWildApricotAttendeeDiscount:(slug, data) => putData(`/api/landing-page/${slug}/basket/wild-apricot/email`, data),
  fetchAgendaGroups:(slug, params) => fetchData(`/api/landing-page/${slug}/basket/agenda-groups`, {params}),
  updateAgendaGroups:(slug, data) => putData(`/api/landing-page/${slug}/basket/agenda-groups`, data),
  fetchPaymentInfo:(slug, data) => sendData(`/api/landing-page/${slug}/basket/payment/prepare`, data),
  confirmSuccessPayment:(slug, params) => fetchData(`/api/landing-page/${slug}/basket/payment/confirm`, {params})
};

export default basketAPI;
